<template>
	<div>
		<fab
			:main-icon="fab.icon"
			:position="fab.position"
			:bg-color="fab.bgColor"
			:actions="fab.fabActions"
			:fixed-tooltip="fab.tooltip"
			@visibility="visibility"
			@add="addInvoice"
			@edit="edit"
			@search="search">
		</fab>

		<search ref="search" :user="user" :isAuth="isAuth" @reload="reload"></search>

		<create
			@reload="reload"
			ref="create"
			:user="user"
			:isAuth="isAuth">
		</create>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import fab from 'vue-fab'
	import Search from '@/components/search/layout/Search'
	import Create from './Create.vue'

	export default {
		props: ['user', 'isAuth', 'data', 'type'],
		components: {
			fab,
			'search': Search,
			'create': Create,
		},
		created() {
			this.init()
		},
		data () {
			return {
				fab: {
					icon: 'reorder',
					bgColor: '#1cb9f2',
					position: 'bottom-right',
					fabActions: null,
					tooltip: true,
				}
			}
		},
		watch: {
			data() {
				this.loadActions()
			},
		},
		methods: {
			init() {
				this.loadActions()
			},
			loadActions() {
				if(this.type == 'show') {
					var actions = []
					if(this.data.orders) {
						if(this.data.orders.length <= 0) {
							actions.push({
								tooltip: 'Editar',
								name: 'edit',
								icon: 'mode_edit',
							})
						}
					}
					actions.push({
						tooltip: 'Buscar',
						name: 'search',
						icon: 'search',
					})
				}
				if(this.type == 'edit') {
					var actions = [
						{
							tooltip: 'Ver',
							name: 'visibility',
							icon: 'visibility',
						},
						{
							tooltip: 'Buscar',
							name: 'search',
							icon: 'search',
						},
					]
				}
				if(this.type == 'index') {
					var actions = [
						{
							tooltip: 'Añadir',
							name: 'add',
							icon: 'add',
						},
						{
							tooltip: 'Buscar',
							name: 'search',
							icon: 'search',
						},
					]
				}

				this.fab.fabActions = actions
			},
			edit() {
				this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/invoices/' + this.data.id + '/edit')
			},
			visibility() {
				this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/admin/management/invoices/' + this.data.id)
			},
			search() {
				this.$refs.search.open('invoices')
			},
			reload() {
				this.$emit('reload')
			},
			addInvoice () {
				this.$refs.create.open()
			},
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/Fab.vue